module.exports = __webpack_public_path__ + "img/dr-valker-adam.65ed7c7f.jpg";